import { create } from "zustand";

export const useConfigurationStore = create((set) => ({
  configuration: null,

  setConfiguration(configuration) {
    set({ configuration });
  },
}));
